import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WindowService } from 'src/@order/services/windows.service';
import * as firebase from 'firebase/app';
import { RecaptchaVerifier, getAuth, signInWithPhoneNumber } from "firebase/auth";
import { MatSnackBar } from '@angular/material/snack-bar';
import { FirebaseApp } from '@angular/fire/compat';
import { ProgressBarService } from 'src/@order/components/progress-bar/progress-bar.service';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.scss']
})
export class OtpDialogComponent implements OnInit, OnDestroy {

  isSelectedOTPMethods: boolean = false;
  OTPMethods = [
    { id: 1, title: 'WhatsApp', icon: 'assets/images/ui/otp-whatsapp.png', isSelected: 0, attemptCounter: 0, isRecommended: 1 },
    { id: 2, title: 'Text message', icon: 'assets/images/ui/otp-message.png', isSelected: 0, attemptCounter: 0, isRecommended: 0 },
    { id: 3, title: 'Voice Call', icon: 'assets/images/ui/otp-phone.png', isSelected: 0, attemptCounter: 0, isRecommended: 0 },
  ]
  selectedMethods;

  windowRef: any;
  appVerifier: any;
  otp: string;
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  phone: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {}
  };
  whatsappOTPdataRes;
  callOTPResData

  verificationId;
  interval;
  // attemptCounter = 1;
  user: any;
  timeCounter: number;
  isErrorShow: boolean = false;
  auth
  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private win: WindowService,
    private _progressBar: ProgressBarService,
    private _auth: AuthServiceLocal,
    private fb: FormBuilder,
    private _snackbar: MatSnackBar,
    public _matDialogRef: MatDialogRef<OtpDialogComponent>,
  ) {
    console.log("data", this._data);
  }

  ngOnInit(): void {

    this.windowRef = this.win.windowRef;
    this.phone = this._data.phoneCode + this._data.phoneNumber;
    this.auth = getAuth();
    console.log("auth", this.auth);


    this.windowRef.recaptchaVerifier = undefined;

    if (!this.windowRef.recaptchaVerifier) {
      this.windowRef.recaptchaVerifier = new RecaptchaVerifier('recaptcha-container', {
        'size': 'invisible',
        'callback': (response) => {
          // console.log("call back response in registration", response)
        },
        'expired-callback': (res) => {
          // console.log("response expired-callback in registration", res)
        }
      }, this.auth);
    }
  }

  sendOTPOnText() {
    signInWithPhoneNumber(this.auth, this.phone, this.windowRef.recaptchaVerifier).then(result => {
      this.setCounter();
      this.windowRef.confirmationResult = result;
      this.verificationId = result.verificationId;
      console.log("signInWithPhoneNumberthisverificationId", this.verificationId);
      this.appVerifier = this.windowRef.recaptchaVerifier;
    }).catch(error => {
      this.isErrorShow = true;
      // Handle errors
      const errorCode = error.code;
      // console.log("errorCode", errorCode);

      const errorMessage = error.message;
      // console.log("errorMessage", errorMessage);

      console.error('Firebase Auth Error:', errorCode, errorMessage);


      // Handle specific errors if needed
      switch (errorCode) {
        case 'auth/invalid-phone-number':
          this._snackbar.open('The phone number is invalid. Please enter a valid phone number.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/missing-phone-number':
          this._snackbar.open('Please enter a phone number.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/quota-exceeded':
          this._snackbar.open('The SMS quota for this project has been exceeded. Please try again later.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/captcha-check-failed':
          this._snackbar.open('Captcha verification failed. Please try again.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/operation-not-allowed':
          this._snackbar.open('Phone number sign-in is not enabled. Please contact support.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/too-many-requests':
          this._snackbar.open('We have blocked all requests from this device due to unusual activity. Please try again later.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/invalid-verification-code':
          this._snackbar.open('The verification code is invalid. Please check the code and try again.', 'OKAY', { duration: 6000 });
          break;
        case 'auth/missing-verification-code':
          this._snackbar.open('Please enter the verification code sent to your phone.', 'OKAY', { duration: 6000 });
          break;
        default:
          this._snackbar.open('An error occurred while sending the OTP. Please try again.', 'OKAY', { duration: 6000 });
          break;
      }
    })
  }

  sendResetPasswordOTPViaWhatsApp() {
    const params = {
      phoneCode: this._data.phoneCode,
      phone: this._data.phoneNumber,
      appType: 3,
      firstName: this._data.firstName || '',
    };
    this._auth.pdasSendResetPasswordMessage(params).subscribe((res) => {
      if (res.response == 1) {
        console.log("pdasSendResetPasswordMessage", res);
        this.whatsappOTPdataRes = res;
      } else {
        this.timeCounter = null;
      }
      this._snackbar.open(res.message, 'OKAY', { duration: 4000 })
    })
  }

  sendOTPViaWhatsApp() {
    const params = {
      phoneCode: this._data.phoneCode,
      phone: this._data.phoneNumber,
      firstName: this._data.firstName || '',
      appType: 3,
    };

    console.log("sendOTPViaWhatsApp", params);

    this._auth.sendOTPViaWhatsApp(params).subscribe((res: any) => {
      if (res.response == 1) {
        // console.log("res sendOTPViaWhatsApp", res);
        this.whatsappOTPdataRes = res;
      } else {
        this.timeCounter = null;
      }
      this._snackbar.open(res.message, 'OKAY', { duration: 4000 })
    })
  }

  sendResetPasswordOTPViaCall() {
    const params = {
      phoneCode: this._data.phoneCode,
      phone: this._data.phoneNumber,
      appType: 3,
    };
    // console.log("params sendOTPViaCall", params);
    this._auth.pdasSendResetPasswordCall(params).subscribe((res: any) => {
      if (res.response == 1) {
        console.log("res sendOTPOverCall", res);
        this.callOTPResData = res;
      } else {
        this.timeCounter = 1;
      }
      this._snackbar.open(res.message, 'OKAY', { duration: 4000 })
    })
  }

  sendOTPViaCall() {
    const params = {
      phoneCode: this._data.phoneCode,
      phone: this._data.phoneNumber,
      appType: 3,
    };
    // console.log("params sendOTPViaCall", params);
    this._auth.sendOTPOverCall(params).subscribe((res: any) => {
      if (res.response == 1) {
        console.log("res sendOTPOverCall", res);
        this.callOTPResData = res;
      } else {
        this.timeCounter = 1;
      }
      this._snackbar.open(res.message, 'OKAY', { duration: 4000 })
    })
  }

  setCounter() {
    if (this.OTPMethods[0].isSelected == 1) {
      this.timeCounter = this.OTPMethods[0].attemptCounter === 1 || this.OTPMethods[0].attemptCounter === 0 ? 15 : this.OTPMethods[0].attemptCounter === 2 ? 20 : this.OTPMethods[0].attemptCounter === 3 ? 30 : 45;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.timeCounter--;
        // console.log("timer counter calling ...... -=>>> ", this.timeCounter);
        if (this.OTPMethods[0].attemptCounter === 2 && this.timeCounter === 0) {
          console.log("now otp via WhatsApp on ");
          // this.setState({ isOTPViaWhatsApp: true });
          // this.sendOTPViaWhatsApp();
        } else if (this.OTPMethods[0].attemptCounter === 3 && this.timeCounter === 0) {
          console.log("now otp via call on ");
          // this.setState({ isOTPViaCall: true });
          // this.sendOTPViaCall()
        }
        if (this.timeCounter <= 0) {
          clearInterval(this.interval);
          // console.log("this.state.attemptCounter --> ", this.attemptCounter);
        }
      }, 1000);

    }
    else if (this.OTPMethods[1].isSelected == 1) {
      this.timeCounter = this.OTPMethods[1].attemptCounter === 1 || this.OTPMethods[1].attemptCounter === 0 ? 15 : this.OTPMethods[1].attemptCounter === 2 ? 20 : this.OTPMethods[1].attemptCounter === 3 ? 30 : 45;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.timeCounter--;
        // console.log("timer counter calling ...... -=>>> ", this.timeCounter);
        if (this.OTPMethods[1].attemptCounter === 2 && this.timeCounter === 0) {
          console.log("now otp via WhatsApp on ");
          // this.setState({ isOTPViaWhatsApp: true });
          // this.sendOTPViaWhatsApp();
        } else if (this.OTPMethods[1].attemptCounter === 3 && this.timeCounter === 0) {
          console.log("now otp via call on ");
          // this.setState({ isOTPViaCall: true });
          // this.sendOTPViaCall()
        }
        if (this.timeCounter <= 0) {
          clearInterval(this.interval);
          // console.log("this.state.attemptCounter --> ", this.attemptCounter);
        }
      }, 1000);
    }
    else if (this.OTPMethods[2].isSelected == 1) {
      this.timeCounter = this.OTPMethods[2].attemptCounter === 1 || this.OTPMethods[2].attemptCounter === 0 ? 15 : this.OTPMethods[2].attemptCounter === 2 ? 20 : this.OTPMethods[2].attemptCounter === 3 ? 30 : 45;
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.timeCounter--;
        // console.log("timer counter calling ...... -=>>> ", this.timeCounter);
        if (this.OTPMethods[2].attemptCounter === 2 && this.timeCounter === 0) {
          console.log("now otp via WhatsApp on ");
          // this.setState({ isOTPViaWhatsApp: true });
          // this.sendOTPViaWhatsApp();
        } else if (this.OTPMethods[2].attemptCounter === 3 && this.timeCounter === 0) {
          console.log("now otp via call on ");
          // this.setState({ isOTPViaCall: true });
          // this.sendOTPViaCall()
        }
        if (this.timeCounter <= 0) {
          clearInterval(this.interval);
          // console.log("this.state.attemptCounter --> ", this.attemptCounter);
        }
      }, 1000);
    }

    // console.log("timer counter values --> ", this.timeCounter);

  }

  /* resend OTP */
  // resendOtp() {
  //   const auth = getAuth();
  //   // console.log("auth in resend otp",auth)
  //   // console.log("this.phone ==>",this.phone)
  //   // console.log("this.appVerifier ==>",this.appVerifier)
  //   if (this.attemptCounter <= 1) {
  //     // console.log("signInWithPhoneNumber");
  //     // SMS 
  //     signInWithPhoneNumber(auth, this.phone, this.appVerifier)
  //     this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
  //     this.attemptCounter++;
  //     this.setCounter();
  //   }
  //   else if (this.attemptCounter == 2) {
  //     // console.log("OTP on Whatsapp");
  //     // OTP on Whatsapp 
  //     this.sendOTPViaWhatsApp();
  //     this.attemptCounter++;
  //     this.setCounter();
  //   }
  //   else {
  //     // console.log("OTP on Call");
  //     // OTP on Call 
  //     this.sendOTPViaCall()
  //     this.attemptCounter++;
  //     this.setCounter();
  //   }

  // }

  ngOnDestroy(): void {
    // console.log("heelo in destroy")
    clearInterval(this.interval);
    this.windowRef.recaptchaVerifier = undefined
  }


  onOtpChange(otp) {
    this.otp = otp;
  }

  checkValidation() {
    return Boolean(String(this.otp)?.length != 6);
  }


  continue() {
    this._progressBar.show();
    // firebase
    if (this.selectedMethods?.id == 2) {
      this.windowRef.confirmationResult?.confirm(this.otp).then(result => {
        // console.log("confirmationResult", result); 
        this.user = result.user;
        if (this.user) {
          clearInterval(this.interval);
          const payload = {
            user: this.user,
            verificationId: result._tokenResponse.idToken,
            otp: this.otp,
            selectedMethods: 2
          }
          this._progressBar.hide();
          if (this._data.useFor == 'forgotPassword') {
            payload['phoneCode'] = this._data.phoneCode;
            payload['phone'] = this._data.phoneNumber;
            payload['appType'] = 3;
            payload['verificationType'] = 1;
            this._matDialogRef.close(payload);
          } else {
            this._matDialogRef.close(payload);
          }
        }
      }).catch(error => {
        this._progressBar.hide();
        this._snackbar.open("Invaild Otp", 'OKay', { duration: 3000 });
      });
    }
    // whatsapp
    else if (this.selectedMethods?.id == 1) {
      // Verify WhatsApp OTP here so dialog remains open on failure
      const verificationParams = {
        phoneCode: this._data.phoneCode,
        phone: this._data.phoneNumber,
        appType: 3,
        verificationType: 2, // WhatsApp verification type
        verificationId: this.whatsappOTPdataRes?.data?.accountSid,
        otp: this.otp,
      };

      this._auth.verifyOTP(verificationParams).subscribe((verifyRes: any) => {
        if (verifyRes?.response == 1) {
          clearInterval(this.interval);
          const payload: any = {
            verificationId: verifyRes.data?.verificationId,
            otp: this.otp,
            selectedMethods: 1,
            // Pass through a flag so the parent can skip re-verification
            verifiedVerificationId: verifyRes.data?.verificationId,
          };
          this._progressBar.hide();
          if (this._data.useFor == 'forgotPassword') {
            payload['phoneCode'] = this._data.phoneCode;
            payload['phone'] = this._data.phoneNumber;
            payload['appType'] = 3;
            payload['verificationType'] = 2;
          }
          this._matDialogRef.close(payload);
        } else {
          this._progressBar.hide();
          this._snackbar.open("Invaild Otp", 'OKay', { duration: 3000 });
        }
      }, _err => {
        this._progressBar.hide();
        this._snackbar.open("Invaild Otp", 'OKay', { duration: 3000 });
      });
    }
    // voice call
    else if (this.selectedMethods?.id == 3) {
      // For voice call, verify OTP here so dialog remains open on failure
      const verificationParams = {
        phoneCode: this._data.phoneCode,
        phone: this._data.phoneNumber,
        appType: 3,
        verificationType: 1, // voice/SMS verification type
        verificationId: this.callOTPResData?.data?.twilloServiceId,
        otp: this.otp,
      };

      this._auth.verifyOTP(verificationParams).subscribe((verifyRes: any) => {
        if (verifyRes?.response == 1) {
          clearInterval(this.interval);
          const payload: any = {
            verificationId: verifyRes.data?.verificationId,
            otp: this.otp,
            selectedMethods: 3,
            // Pass through a flag so the parent can skip re-verification
            verifiedVerificationId: verifyRes.data?.verificationId,
          };
          this._progressBar.hide();
          if (this._data.useFor == 'forgotPassword') {
            payload['phoneCode'] = this._data.phoneCode;
            payload['phone'] = this._data.phoneNumber;
            payload['appType'] = 3;
            payload['verificationType'] = 2;
          }
          this._matDialogRef.close(payload);
        } else {
          this._progressBar.hide();
          this._snackbar.open("Invaild Otp", 'OKay', { duration: 3000 });
        }
      }, _err => {
        this._progressBar.hide();
        this._snackbar.open("Invaild Otp", 'OKay', { duration: 3000 });
      });
    }
  }

  onSelectOtpMethod(item) {
    this.OTPMethods.forEach(element => element.isSelected = 0);
    item.isSelected = 1;
    this.selectedMethods = item;
  }

  checkSendOTPValidation() {
    return !(this.OTPMethods.some(item => item.isSelected))
  }

  sendOTP() {
    // Whatsapp 
    if (this.selectedMethods?.id == 1) {
      if (this._data.useFor == 'forgotPassword') {
        this.sendResetPasswordOTPViaWhatsApp();
      } else {
        this.sendOTPViaWhatsApp();
      }
      if (this.OTPMethods[0].attemptCounter != 0) {
        if (this.OTPMethods[0].attemptCounter <= 1) {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[0].attemptCounter++;
          this.setCounter();
        } else if (this.OTPMethods[0].attemptCounter == 2) {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[0].attemptCounter++;
          this.setCounter();
        } else {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[0].attemptCounter++;
          this.setCounter();
        }
      } else {
        this.OTPMethods[0].attemptCounter++;
      }
    }
    // Text
    else if (this.selectedMethods?.id == 2) {
      this.sendOTPOnText();
      if (this.OTPMethods[1].attemptCounter != 0) {
        if (this.OTPMethods[1].attemptCounter <= 1) {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[1].attemptCounter++;
          this.setCounter();
        } else if (this.OTPMethods[1].attemptCounter == 2) {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[1].attemptCounter++;
          this.setCounter();
        } else {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[1].attemptCounter++;
          this.setCounter();
        }
      } else {
        this.OTPMethods[1].attemptCounter++;
      }
    }
    // Voice Call
    else if (this.selectedMethods?.id == 3) {

      if (this._data.useFor == 'forgotPassword') {
        this.sendResetPasswordOTPViaCall();
      } else {
        this.sendOTPViaCall();
      }

      if (this.OTPMethods[2].attemptCounter != 0) {
        if (this.OTPMethods[2].attemptCounter <= 1) {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[2].attemptCounter++;
          this.setCounter();
        } else if (this.OTPMethods[2].attemptCounter == 2) {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[2].attemptCounter++;
          this.setCounter();
        } else {
          this._snackbar.open("Otp sent again", "Okay", { duration: 2000 })
          this.OTPMethods[2].attemptCounter++;
          this.setCounter();
        }
      } else {
        this.OTPMethods[2].attemptCounter++;
      }
    }

    this.isSelectedOTPMethods = true;
    // this.setCounter();

  }

  phoneNumberFormat(phoneNumber) {
    return '*****' + String(phoneNumber).slice(-4);
  }

  reSetAndBack() {

    this.isSelectedOTPMethods = false;
    this.OTPMethods.forEach((ele) => {
      ele.attemptCounter = 0;
      ele.isSelected = 0;
    })
    this.selectedMethods = null;
    this.timeCounter = null;
    clearInterval(this.interval);

  }


}

